import { render, staticRenderFns } from "./batchUpdateProductState.vue?vue&type=template&id=22591961&scoped=true"
import script from "./batchUpdateProductState.vue?vue&type=script&lang=js"
export * from "./batchUpdateProductState.vue?vue&type=script&lang=js"
import style0 from "./batchUpdateProductState.vue?vue&type=style&index=0&id=22591961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22591961",
  null
  
)

export default component.exports